module.exports = __webpack_public_path__ + "static/img/ctimg9.4ea5f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctimg9.png
// module id = gLXi
// module chunks = 5